import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  workkardListingData: {
    workkardsFullData: [],
    total: 0,
    skip: 0,
    take: 0,
    page: 1,
    status: '',
    sortDir: 'DESC',
    sortBy: 1,
  },
  workkardListingTabs: {
    openCount: 0,
    closeCount: 0,
    unassignedCount: 0,
    watchingCount: 0,
  },
  pagingModel: {
    page: 1,
    totalCount: 0,
    rows: 0,
  },
  isLoading: false,
  error: null,
};

const workkardListingSlice = createSlice({
  name: 'workkardListing',
  initialState,
  reducers: {
    fetchWorkkardTabCountRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchWorkkardTabCountSuccess: (state, action) => {
      state.isLoading = false;
      state.workkardListingTabs = {
        ...state.workkardListingTabs,
        ...action.payload,
      };
    },
    fetchWorkkardTabCountFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchWorkkardListingDataRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchWorkkardListingDataSuccess: (state, action) => {
      state.isLoading = false;
      const { isScroll, ...data } = action.payload;
      
      if (isScroll) {
        state.workkardListingData = {
          ...data,
          workkardsFullData: [
            ...state.workkardListingData.workkardsFullData,
            ...data.workkardsFullData,
          ],
        };
      } else {
        state.workkardListingData = data;
      }
    },
    fetchWorkkardListingDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    updatePagingModel: (state, action) => {
      state.pagingModel = {
        page: action.payload.page,
        totalCount: action.payload.totalCount,
        rows: action.payload.rows,
      };
    },

    resetWorkkardListingData: (state) => {
      state.workkardListingData = initialState.workkardListingData;
    },

    updateTabCount: (state, action) => {
      state.workkardListingTabs = {
        ...state.workkardListingTabs,
        ...action.payload,
      };
    },
  },
});

export const {
  fetchWorkkardTabCountRequest,
  fetchWorkkardTabCountSuccess,
  fetchWorkkardTabCountFailure,
  fetchWorkkardListingDataRequest,
  fetchWorkkardListingDataSuccess,
  fetchWorkkardListingDataFailure,
  updatePagingModel,
  resetWorkkardListingData,
  updateTabCount,
} = workkardListingSlice.actions;

export default workkardListingSlice.reducer;

export const selectWorkkardListingData = (state) => state.workkardListing.workkardListingData;
export const selectWorkkardListingTabs = (state) => state.workkardListing.workkardListingTabs;
export const selectPagingModel = (state) => state.workkardListing.pagingModel;
export const selectIsLoading = (state) => state.workkardListing.isLoading;
export const selectError = (state) => state.workkardListing.error;
